// Check(XR 핫스팟 점검 관리 시스템) 모듈 매니페스트
// Core 로더가 이 객체를 읽어 라우터/스토어/네비에 주입한다.
// 백엔드는 분리 유지(Check BE 8751, Unity XR 클라이언트와 공유). 프론트만 통합.
import routes from "./routes";

export default {
  code: "CHECK", // master_module.ExternalValue
  appCode: "CHECK_WEB", // 권한 매핑 (Auth 서버 identity_user_application)
  name: "Check",
  routes, // AppShell children 으로 주입
  store: {}, // Check 뷰는 vuex 미사용 (자체 완결)
  // SideNav 그룹/메뉴 (7단계에서 /api/core/nav 권한 필터로 대체 예정)
  nav: {
    code: "CHECK",
    // i18n 키 (AppSideNav 가 $t 로 렌더). checkNav 네임스페이스 = core/i18n/locales
    name: "checkNav.title",
    menus: [
      { name: "checkNav.dashboard", path: "/check/dashboard" },
      { name: "checkNav.positionAdd", path: "/check/positionAdd" },
      { name: "checkNav.positionSelect", path: "/check/positionSelect" },
      { name: "checkNav.pointAdd", path: "/check/pointAdd" },
      { name: "checkNav.pointSelect", path: "/check/pointSelect" },
      { name: "checkNav.checkResult", path: "/check/checkResult" },
      { name: "checkNav.checkResultReport", path: "/check/checkResultReport" },
    ],
  },
  i18n: {},
};
